module.exports = ""


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/components/menu-right/menu-right.component.html
// module id = ../../../../../src/app/common/components/menu-right/menu-right.component.html
// module chunks = main